module.exports = __webpack_public_path__ + "img/p63.9da809e9.png";